/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */

import Vue from 'vue';

export default {
    props: {
        content: {
            type: Array,
        },
        selectedModelVersion: {
            type: String,
        },
    },

    data() {
        return {
            modelVersion: this.selectedModelVersion,
            selectedContentForModelSwitcher: null,
        };
    },

    mounted() {
        this.handleSetSelectedContentByModelVersion(this.modelVersion);
    },

    watch: {
        modelVersion: function (newVersionHandle) {
            this.handleSetSelectedContentByModelVersion(newVersionHandle);
        },
        selectedModelVersion: function (newVersionHandle) {
            this.modelVersion = newVersionHandle;
        },
    },

    methods: {
        slugifyModelVersionName(modelVersionName) {
            return modelVersionName.replace(/\s+/g, '-').toLowerCase();
        },

        handleSetSelectedContentByModelVersion(versionHandle) {
            this.selectedContentForModelSwitcher = this.content.find(
                (switcher) => switcher.modelVersionHandle === versionHandle,
            );
        },

        changeModelVersion(versionHandle, modelVersionName) {
            window.location.hash = modelVersionName
                .replace(/\s+/g, '-')
                .toLowerCase();
            this.modelVersion = versionHandle;
            EventBus.$emit('model-version-changed', versionHandle);
        },

        isModelSelected(modelVersionName, className) {
            const slugifiedModelVersionName =
                this.slugifyModelVersionName(modelVersionName);
            return this.$parent.selectedModelType === slugifiedModelVersionName
                ? `${className}--selected`
                : '';
        },
    },
};
